import { render, staticRenderFns } from "./inputNumber.pug?vue&type=template&id=116eba6e&lang=pug&"
import script from "./inputNumber.js?vue&type=script&lang=js&"
export * from "./inputNumber.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116eba6e')) {
      api.createRecord('116eba6e', component.options)
    } else {
      api.reload('116eba6e', component.options)
    }
    module.hot.accept("./inputNumber.pug?vue&type=template&id=116eba6e&lang=pug&", function () {
      api.rerender('116eba6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/number/index.vue"
export default component.exports